module.exports = __webpack_public_path__ + "img/logo-fullsail-dark.3bce79d2.svg";